export default __webpack_public_path__ + "static/designer-7bdc8f7c9e49d22f15c50f80118f05bc.svg";